import en from './en'
import de from '@/locales/de.js'
import nl from '@/locales/nl.json'
import es from '@/locales/es.json'
import fa from '@/locales/fa.js'
import fr from '@/locales/fr.json'
import pt from '@/locales/pt.json'
import ru from '@/locales/ru.js'
import zh from '@/locales/zh.json'

export default {
  de: de,
  nl: nl.default,
  en: en,
  es: es.default,
  fa: fa,
  fr: fr.default,
  pt: pt.default,
  zh: zh.default,
  ru: ru
}
